import { ProductType, ProductTypeDiscounts } from '@mfe/shared/schema-types';

import { GetPriceAndDiscountResult } from '../types';

export const getPriceAndDiscount = (
  addon: ProductType
): GetPriceAndDiscountResult => {
  const prices = addon.prices;

  if (
    !prices ||
    prices.length === 0 ||
    prices[0]?.amount?.value === undefined
  ) {
    return { price: 0, promotions: [] };
  }

  const price = prices[0].amount.value;
  const { discounts } = addon;

  if (!discounts) {
    return { price, promotions: [] };
  }

  const { total_discounts, itemized_discounts } = discounts;
  const result: GetPriceAndDiscountResult = {
    oldPrice: price,
    price,
    promotions: [],
    totalPromotionDuration: 0,
  };

  const amountTotal = calculateTotalDiscountAmount(total_discounts);
  result.totalPromotionDuration = calculateTotalPromotionDuration(
    total_discounts,
    itemized_discounts
  );
  result.promotions = extractPromotions(itemized_discounts);

  if (amountTotal !== 0) {
    result.price = price + amountTotal;
  }

  return result;
};

const calculateTotalDiscountAmount = (
  total_discounts: ProductTypeDiscounts['total_discounts']
): number => {
  return total_discounts?.amount?.value || 0;
};

const calculateTotalPromotionDuration = (
  total_discounts: ProductTypeDiscounts['total_discounts'],
  itemized_discounts: ProductTypeDiscounts['itemized_discounts']
) => {
  if (total_discounts?.duration) {
    return total_discounts.duration;
  }

  for (const discount of itemized_discounts || []) {
    if (discount?.duration) {
      return discount.duration;
    }
  }
};

const extractPromotions = (
  itemized_discounts: ProductTypeDiscounts['itemized_discounts']
) => {
  const promotions = [];
  for (const discount of itemized_discounts || []) {
    if (discount?.name && discount?.amount?.value) {
      promotions.push({ name: discount.name, amount: discount.amount.value });
    }
  }
  return promotions;
};
